import React, { useContext } from "react";
import ApplicationContext from "../../../context/index";
import ApplicationList from "./list";
import CallToAction from "../partials/cta";
import ErrorMessage from "../partials/error";
import RemoveProposalAlert from "./alert";
import SectionTitle from "../../../components/sectionTitle";
import { withStyles } from "@mui/styles";
import { Box } from "@mui/material";
import { useStyles } from "../indexFormStyles";
import { BUTTON_START_NEW_JOURNEY } from "../../../constants";

function QuotationDetailsForm({
  classes: { contentScroller, containerButton, main },
  errors,
  handleClick,
  handleOnClose,
  handleProceed,
  modal,
  onSubmit,
}) {
  const { state, dispatch } = useContext(ApplicationContext);
  return (
    <Box className={main}>
      <form noValidate autoComplete="off" onSubmit={onSubmit}>
        <Box className={contentScroller}>
          <Box display="flex" justifyContent="center" m={2} mt={0} mb={1}>
            <SectionTitle hideBack={true} title={"Application Details"} />
          </Box>

          <ApplicationList onClickHandler={handleClick} />

          <ErrorMessage errors={errors} modal={modal} />
        </Box>

        {state?.proposalList?.length > 0 && (
          <Box
            className={containerButton}
            justifyContent="center"
            alignContent="center"
          >
            <CallToAction
              buttonType={"submit"}
              handleClick={() => {}}
              text={BUTTON_START_NEW_JOURNEY}
            />
          </Box>
        )}
      </form>

      {modal.alert && (
        <RemoveProposalAlert
          onClickHandler={handleProceed}
          onClose={handleOnClose}
          modal={modal}
        />
      )}
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(QuotationDetailsForm);
